import React from 'react';

import globalClasses from '../../../App.module.css';

const ParamsList = () => {
    return (
        <ul className={globalClasses.ParamsList}>
            <li>
                <b>outcomeId </b>
                <i>
                    the id of the outcome for which the betOffer label is needed
                    <b>*</b>
                </i>
            </li>
            <li>
                <b>betOffer </b>
                <i>
                    object with the betOffer of that outcome <b>*</b>
                </i>
            </li>
            <li>
                <b>event </b> <i>object with the event of that outcome</i>
            </li>
            <li>
                <b>selections </b>{' '}
                <i>object with the horse racing selections</i>
            </li>
            <li>
                <b>multiPositionBetOfferLabelOneLine </b>
                <i>
                    boolean - this applies only for the horse racing bet offers
                    (Tricast and Forecast bet types), and decides if the
                    participants will be displayed in one line separated by
                    comma (set it on true), or on separated lines (set it on
                    false) eg: <br></br>1st ParticipantName <br></br> 2nd
                    ParticipantName
                </i>
            </li>
            <li>
                <b>getTranslationCallback </b>
                <i>
                    a callback that will return the translated text based on
                    some keys
                </i>
            </li>
        </ul>
    );
};

export default ParamsList;
